import React from 'react'
import { connect } from 'react-redux'
import {
  showPopupDialog,
  showPopupErrorSnackbar,
  showPopupSuccessSnackbar,
} from 'support/popup_dialogs'
import i18n from 'support/i18n'
import Navigation from 'support/navigation'
import ErrorSubmitModal from './dialogs/ErrorSubmitContainer'
import SucessSubmitModal from './dialogs/SucessSubmitContainer'
import View from './View'
import { putScorecardTemplateEdit,getScorecardTemplateEditID } from 'services/innovate/templates'

const mapStateToProps = state => ({
  myEmail: state.data.user.userEmail,
  createScorecardTemplateLoading: state.data.templates.createScorecardTemplateLoading,
  updateScorecardTemplateLoading: state.data.templates.updateScorecardTemplateLoading,
  createScorecardTemplate:state.data.templates.createScorecardTemplate,
  updateScorecardTemplate:state.data.templates.updateScorecardTemplate,

  editIdScorecardTemplateLoading: state.data.templates.editIdScorecardTemplateLoading,
  editIdScorecardTemplateData:state.data.templates.editId_ScorecardTemplate,
})

const mapDispatchToProps = dispatch => {
  return {
    putScorecardTemplateEditFn:(email,scorecardTemplateJsonValue=[],id)=>{
      // console.log("edit Value", adminEditTemplateData)
      const onSuccess = data => {
        const message='Your Scorecard Template is Successfully Save'
        // showPopupSuccessSnackbar(message, dispatch)
        showPopupDialog(<SucessSubmitModal description={message} />, dispatch)
      }
      const onFailure = ({ data }) => {
        const messageTag =
          data && data?.error && data?.error?.en
            ? `BACKEND_ERRORS.${data?.error?.en}`
            : 'BACKEND_ERRORS.UNEXPECTED'
            showPopupDialog(<ErrorSubmitModal description={messageTag} />, dispatch)
      }
      dispatch(putScorecardTemplateEdit(email,scorecardTemplateJsonValue,id,onSuccess,onFailure))
      
    },

    getScorecardTemplateEditIDFn:(templateIdParams)=>{
      dispatch(getScorecardTemplateEditID(templateIdParams))
    }

  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)
